import {
  AppBar,
  AppBarProps,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import styled from "styled-components";

const FlexGrow = styled.div(
  () => `
    flex-grow:1;
`
);

const CoverAppBar: React.FC<AppBarProps> = ({ children, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar {...props}>
      <Toolbar
        sx={{
          paddingBottom: isMobile ? "100px" : "0px",
          paddingTop: isMobile ? "30px" : "0px",
        }}
      >
        <FlexGrow />
        {children}
      </Toolbar>
    </AppBar>
  );
};

const StyledCoverAppBar = styled(CoverAppBar)`
  background: white;

  ${(props) => props.theme.breakpoints.down("sm")} {
    position: fixed;
    top: auto;
    bottom: 0;
  }

  ${(props) => props.theme.breakpoints.up("sm")} {
    position: relative;
    top: auto;
    bottom: auto;
    margin-left: -24px;
    margin-right: -24px;
    margin-bottom: -70px;
    width: calc(100% + 48px);
  }
`;

export default StyledCoverAppBar;
